export default "__VITE_ASSET__BQ0B6oED__"